export default __webpack_public_path__ + "static/media/compare-schedule.d3d08236.svg";